import type { ThreeSidePathsType } from "@tosize/shapes/src/types/three";
import { useMemo } from "react";
import { type Material, Shape, ShapeGeometry } from "three";
import { RENDER_QUALITY } from "./Shape";

interface TopProps {
	paths?: Array<ThreeSidePathsType>;
	material: Material;
	zPosition: number;
}

export function Top({ paths, zPosition, material }: TopProps) {
	const geometry = useMemo(() => {
		const points = paths?.flatMap((sideData) => sideData.path.getPoints(RENDER_QUALITY));

		return new ShapeGeometry(new Shape(points));
	}, [paths]);

	return <mesh geometry={geometry} material={material} position={[0, 0, zPosition]} />;
}
